<template>
  <div class="statistic-widget-order-quantity">
    <h5 class="mb-0 title">Order Quantity</h5>
    <Chart :config="chartConfig" class="chart" />
  </div>
</template>

<script>
import Chart from '@/components/Chart.vue'
export default {
  components: {
    Chart
  },
  data() {
    return {
      selected: 'today'
    }
  },
  computed: {
    data() {
      return this.config?.data
    },
    chartConfig() {
      let options = {
        yAxis: [{ visible: false }, { visible: false }],
        tooltip: {
          crosshairs: true,
          shared: true,
          headerFormat: `<b>${this.data?.labels?.label}: {point.x}</b><br>`
        },
        plotOptions: {
          spline: {
            dataLabels: {
              enabled: true,
              format: '{y}'
            },
            yAxis: 1
          },
          column: {
            borderRadius: {
              radius: '50%',
              where: 'all'
            },
            pointWidth: 12
          }
        }
      }
      return {
        options: Object.assign(options, this.options(this.data || {}))
      }
    }
  },
  methods: {
    options(items) {
      let results = {
        categories: [],
        columns: {},
        quality: []
      }
      items?.data.forEach((values) => {
        Object.entries(values).forEach(([index, item]) => {
          if (index == 'label') {
            results.categories.push(item)
          } else if (index == 'quality') {
            results.quality.push(item)
          } else {
            if (!results.columns?.[index]) {
              results.columns[index] = {
                name: items.labels?.[index],
                type: 'column',
                data: []
              }
            }
            results.columns[index].data.push(item)
          }
        })
      })
      return {
        xAxis: {
          categories: results.categories,
          lineWidth: 0
        },
        series: [
          ...Object.values(results.columns),
          {
            name: items.labels?.quality,
            type: 'spline',
            data: results.quality
          }
        ]
      }
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-order-quantity {
  .chart {
    max-height: 350px;
  }
}
</style>
